import styled from 'styled-components';
import LoadingShape from 'components/LoadingShape';
import {
    Content,
    DetailsGrid,
    EmptyMessageContainer,
    PatientHeader,
    SectionHeader,
} from '../CustomerNexhealthTab/styled';

export const PanelBody = styled(Content)`
    ${PatientHeader} {
        align-items: flex-start;
        padding-bottom: 1rem;
    }

    ${DetailsGrid} {
        grid-template-columns: minmax(0, 1fr);
    }

    ${SectionHeader} {
        flex-wrap: wrap;
    }

    ${EmptyMessageContainer} {
        margin-top: 2rem;
    }
`;

export const SkeletonBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
`;

export const SkeletonLine = styled(LoadingShape)`
    > div {
        border-radius: 1rem;
    }
`;
